import InfiniteScroll from "react-infinite-scroll-component"
import PullToRefresh from "react-simple-pull-to-refresh"

import { NotificationItem } from "@/components/others/notification/notification-item"
import { LoadingSpinner } from "@/components/shared/icons/svg"
import { Notification } from "@/modules/types"

interface NotificationListProps {
  notifications: Notification[]
  isLoading: boolean
  hasNextPage: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  onRefresh: () => Promise<void>
  emptyMessage?: string
  scrollableTargetIds?: string
  className?: string
}

export const NotificationList = ({
  notifications,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onRefresh,
  emptyMessage = "Không có thông báo trong mục này.",
  scrollableTargetIds = "screen-scroll-container",
  className
}: NotificationListProps) => {
  return (
    <InfiniteScroll
      dataLength={notifications?.length || 0}
      next={() => !isFetchingNextPage && hasNextPage && fetchNextPage()}
      hasMore={hasNextPage}
      scrollableTarget={scrollableTargetIds}
      scrollThreshold={0.9}
      loader={
        <div className="flex justify-center py-4">
          <LoadingSpinner className="w-20 h-20" />
        </div>
      }
    >
      <PullToRefresh
        onRefresh={onRefresh}
        pullingContent=""
        maxPullDownDistance={80}
        refreshingContent={<LoadingSpinner className="w-20 h-20" />}
      >
        <div className={`bg-white pb-16 ${className || ""}`}>
          {!notifications.length && !isLoading && (
            <div className="h-[50vh] flex items-center justify-center text-gray-400 text-xs px-4">
              {emptyMessage}
            </div>
          )}
          {isLoading && (
            <div className="h-[50vh] flex items-center justify-center">
              <LoadingSpinner className="w-20 h-20" />
            </div>
          )}
          {notifications.map((notification, index) => (
            <NotificationItem key={notification.id} index={index} data={notification} />
          ))}
        </div>
      </PullToRefresh>
    </InfiniteScroll>
  )
}
